module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADIAQMAAACXljzdAAAABlBMVEXz8/PLysp6eCx3AAAAfUlEQVR4Xu3UQQqAIBAF0AEXLT1CR+lqXa2beISWs2oShSawcDEgZn8WKrzVH+STvE1vAoFAAuVxTwJZDpeOikC2ihS7/pBonoYSyA0tlKed7NEnk2ief0p6+ks4LckbhfJ8R2bhWx4vq7BBIGP8A4q3RSDoAwj6QAWCPoCcV9X+HDmlgb0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/files/company-logo.png
// module id = 157
// module chunks = 0